<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                :to="{
                    name: 'wo-bom-search',
                }"
            >
                SEARCH
            </v-tab>
            <v-tab
                :to="{
                    name: 'wo',
                }"
            >
                Work Orders
            </v-tab>
            <v-tab
                :to="{
                    name: 'finished-wo',
                }"
            >
                Finished Work Orders
            </v-tab>
            <v-tab
                :to="{
                    name: 'closed-wo',
                }"
            >
                Closed Work Orders
            </v-tab>
            <v-tab
                :to="{
                    name: 'operator-wo-progress',
                }"
            >
                WO Progress
            </v-tab>
            <v-tab
                :to="{
                    name: 'operator-qa-rejected-wo',
                }"
                v-if="markQualityRegisters"
            >
                QA Rejected
            </v-tab>
            <v-tab
                :to="{
                    name: 'quality-pending',
                }"
                v-if="markQualityRegisters"
            >
                QA Pending
            </v-tab>
            <v-tab
                :to="{
                    name: 'operator-wo-deliveries',
                }"
            >
                Deliveries
            </v-tab>
            <v-tab
                :to="{
                    name: 'bom',
                }"
            >
                Bill Of Materials
            </v-tab>
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import SocketioService from '@/services/websocket/socket.service.js'
import API from '@/services/api'

export default {
    name: 'Operator',
    data: () => ({
        loading: true,
        height: 0,
        companyId: JSON.parse(localStorage.getItem('company')),
        markQualityRegisters: undefined,
    }),
    async mounted() {
        this.onResize()
        const {
            data: { user },
        } = await API.getMyInfo()
        this.approvedPermission = user.permissions.includes('approvedWO')
        this.markQualityRegisters = user.permissions.includes(
            'markQualityRegisters'
        )
        SocketioService.connect({
            companyId: this.companyId,
        })
    },
    beforeDestroy() {
        SocketioService.leaveRoom(`${this.companyId}-BOM`)
        SocketioService.disconnect()
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
}
</style>
